/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NovitusReceiptPayloadDto } from './NovitusReceiptPayloadDto';
import {
    NovitusReceiptPayloadDtoFromJSON,
    NovitusReceiptPayloadDtoFromJSONTyped,
    NovitusReceiptPayloadDtoToJSON,
} from './NovitusReceiptPayloadDto';

/**
 * 
 * @export
 * @interface GenerateReceiptResponseDto
 */
export interface GenerateReceiptResponseDto {
    /**
     * ID wygenerowanego paragonu
     * @type {string}
     * @memberof GenerateReceiptResponseDto
     */
    receiptId: string;
    /**
     * Dane do fiskalizacji paragonu
     * @type {NovitusReceiptPayloadDto}
     * @memberof GenerateReceiptResponseDto
     */
    payload: NovitusReceiptPayloadDto;
    /**
     * Zbuforowany aktualny token drukarki, jeśli dostępny
     * @type {string}
     * @memberof GenerateReceiptResponseDto
     */
    token?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GenerateReceiptResponseDto
     */
    tokenExpiresAt?: string | null;
}

/**
 * Check if a given object implements the GenerateReceiptResponseDto interface.
 */
export function instanceOfGenerateReceiptResponseDto(value: object): value is GenerateReceiptResponseDto {
    if (!('receiptId' in value) || value['receiptId'] === undefined) return false;
    if (!('payload' in value) || value['payload'] === undefined) return false;
    return true;
}

export function GenerateReceiptResponseDtoFromJSON(json: any): GenerateReceiptResponseDto {
    return GenerateReceiptResponseDtoFromJSONTyped(json, false);
}

export function GenerateReceiptResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateReceiptResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'receiptId': json['receiptId'],
        'payload': NovitusReceiptPayloadDtoFromJSON(json['payload']),
        'token': json['token'] == null ? undefined : json['token'],
        'tokenExpiresAt': json['tokenExpiresAt'] == null ? undefined : json['tokenExpiresAt'],
    };
}

export function GenerateReceiptResponseDtoToJSON(value?: GenerateReceiptResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'receiptId': value['receiptId'],
        'payload': NovitusReceiptPayloadDtoToJSON(value['payload']),
        'token': value['token'],
        'tokenExpiresAt': value['tokenExpiresAt'],
    };
}

